<template>
    <div>
        <b-modal
                v-model="show"
                @hide="close(false)"
                size="lg"
                no-close-on-backdrop
                title="Регистрация клиента"
        >
            <b-container align-center>
                <div class="custom-group-label mb-2">Заполните данные. <br>Пароль придет на указанный номер телефона</div>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <label class="custom-input-label">ФИО <span class="mark-required">*</span></label>
                        <b-input
                                placeholder="Иванов Иван Иванович"
                                v-model="editClientModel.fullName"
                                :state="errors.findIndex(x=>x.key='fullName')!=-1?editClientModel.fullName!=null&&editClientModel.fullName!=''?true:false:null"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <label class="custom-input-label">Дата рождения <span class="mark-required">*</span></label>
                        <b-input
                                type="date"
                                placeholder="дд.ММ.гггг"
                                v-model="editClientModel.dateBirth"
                                :state="errors.findIndex(x=>x.key='dateBirth')!=-1?editClientModel.dateBirth!=null&&editClientModel.dateBirth!=''?true:false:null"
                        />
                    </b-col>
                </b-row>

                <b-row no-gutters class="mb-1">
                    <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                        <label class="custom-input-label">Марка транспортного средства <span class="mark-required">*</span></label>
                        <b-select
                                v-model="editClientModel.carMarkId"
                                :state="errors.findIndex(x=>x.key='carMarkId')!=-1?editClientModel.carMarkId!=null?true:false:null"
                                :options="Marks"
                                @input="markSelect"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                        <label class="custom-input-label">Модель <span class="mark-required">*</span></label>
                        <b-select
                                :disabled="editClientModel.carMarkId==null"
                                v-model="editClientModel.carModelId"
                                :state="errors.findIndex(x=>x.key='carModelId')!=-1?editClientModel.carModelId!=null?true:false:null"
                                :options="Models"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <label class="custom-input-label">Год выпуска <span class="mark-required">*</span></label>
                        <b-input
                                v-model="editClientModel.carYear"
                                type="number"
                                :state="errors.findIndex(x=>x.key='carYear')!=-1?editClientModel.carYear!=null&&editClientModel.carYear!=''?true:false:null"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <label class="custom-input-label">Гос.номер ТС</label>
                        <b-input
                                v-model="editClientModel.carNumber"
                                placeholder="A000AA00"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                        <label class="custom-input-label">Адрес филиала регистрации</label>
                        <b-select
                                :options="partnerBranches"
                                text-field="address"
                                value-field="id"
                                v-model="editClientModel.orgGeoInfoId"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                        <label class="custom-input-label">Тип бонусного пакета <span class="mark-required">*</span></label>
                        <b-select
                                :options="packages"
                                text-field="name"
                                value-field="id"
                                :state="errors.findIndex(x=>x.key='bonusPacketId')!=-1?editClientModel.bonusPacketId!=null&&editClientModel.bonusPacketId!=''?true:false:null"
                                v-model="editClientModel.bonusPacketId"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                        <label class="custom-input-label">Email</label>
                        <b-input
                                v-model="editClientModel.eMail"

                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col cols="12" sm="8" md="8" lg="8" xl="8">
                        <label class="custom-input-label">Телефон <span class="mark-required">*</span></label>
                        <b-input
                                v-model="editClientModel.account"
                                class="phone"
                                :state="stateLogin"
                                :formatter="formatPhone"
                                aria-describedby="input-login-feedback input-login-valid"
                                @change="checkLogin"
                        /><label class="phone" data-fon="+7">&nbsp;</label>

                        <!-- This will only be shown if the preceding input has an invalid state -->
                        <b-form-invalid-feedback :state="stateLogin">
                            {{ this.loginMes }}
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="stateLogin">
                            {{ this.loginMes }}
                        </b-form-valid-feedback>

                    </b-col>
                </b-row>
            </b-container>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <v-row no-gutters  justify="space-between">

                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-blue)"
                                    dark
                                    size="sm"
                                    @click="onSave"
                            >
                                Сохранить
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="close(false)"
                            >
                                Отмена
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </b-modal>
        <b-modal
                centered
                v-model="showSuccess"
                @hide="close(true)"
                size="md"
                title="Пароль отправлен"
        >
            <b-container>
                <span class="password-send-label">Пароль успешно отправлен на номер +7{{editClientModel.account}}</span>
            </b-container>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <v-row no-gutters  justify="space-between">
                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    style="padding: 0; margin: 0; min-width: 40px; height: 40px"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="close(true)"
                            >
                                <span><v-icon >mdi-arrow-left</v-icon></span>
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>

                    </v-row>
                </div>
            </template>
        </b-modal>
    </div>

</template>

<script>
    import mapper from 'automapper'
    import { mapGetters } from 'vuex';
    import axios from 'axios'
    export default {
        name: "AddClientModal",
        props:['show', 'organizationItem'],
        data(){
            return {
                showSuccess:false,
                errors:[],
                identityModel: {
                    login: null,
                    email: null,
                    phoneNumber: null,
                    password: null,
                    userName: null,
                    isClient: false,
                    isAdministrator: false,
                    organizationId: null,
                    webSite: '',
                },
                editClientModel: {
                    id: null,
                    account: null,
                    fullName: null,
                    eMail: null,
                    identityId:null,
                    isActive: true,
                    organizationId: null,
                    orgGeoInfoId:null,
                    carModelId: null,
                    carMarkId: null,
                    carNumber:null,
                    carYear: 0,
                    bonusPacketId:null,
                    dateBirth:null,
                },
                correctLogin: null,
                loginMes: null
            }
        },
        created(){
            //получить список бонусных пакетов
            this.$store.dispatch("Bonuses/loadBonusPackages").catch(err=>{
                console.log(err)
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка пользователей!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            });



            this.$store.dispatch("Cars/loadMarks").catch((err) => {
                console.log(err)
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки марок авто!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            });

            mapper.createMap("Client", "editClientModel")
                .forMember('password', function () {
                    this.ignore();
                });

            mapper.createMap("editMobileUserModel", "identityModel")
                .forMember('login', function () {
                    this.mapFrom('account')
                })
                .forMember('userName', function () {
                    this.mapFrom('fullName')
                })
                .forMember('isAdministrator', function () {
                    this.ignore()
                })
                .forMember('isClient', function () {
                    this.ignore()
                })
                .forMember('webSite', function () {
                    return null
                })
                .forMember('phoneNumber', function () {
                    this.mapFrom('account')
                })
                .forMember('email', function () {
                    this.mapFrom('eMail')
                })
                .forMember('password', function () {
                    this.ignore()
                })
        },
        computed:{
            ...mapGetters({
                carModels:"Cars/getModels",
                webUserInfo:"userData/getWebUser"
            }),

            stateLogin(){
                if(this.errors.findIndex(x=>x.key='account')!=-1){
                    if( this.editClientModel.account!=null&&this.editClientModel.account!=''){
                        return this.correctLogin;
                    }
                    else return false;
                }
                else if( this.editClientModel.account!=null&&this.editClientModel.account!=''){
                    return this.correctLogin;
                }
                else return this.errors.findIndex(x=>x.key='account')!=-1?this.editClientModel.account!=null&&this.editClientModel.account!=''?true:false:null;
            },

            //список марок
            Marks() {
                var res = [];
                var items = this.$store.state.Cars.carMarks;
                if (items != null) {
                    items.sort((a,b)=>{
                        var nameA=a.carMarkName.toLowerCase(), nameB=b.carMarkName.toLowerCase()
                        if (nameA < nameB)
                            return -1
                        if (nameA > nameB)
                            return 1
                        return 0
                    }).forEach(item => {
                        res.push({text: item.carMarkName, value: item.id})
                    })
                }
                return res;
            },

            //получить список моделей выбранной марки
            Models(){
                if(this.editClientModel.carMarkId!=null){
                    var items =this.carModels(this.editClientModel.carMarkId);
                    if(items!=null) {
                        var res=[];
                        items.sort((a,b)=>{
                            var nameA=a.carModelName.toLowerCase(), nameB=b.carModelName.toLowerCase()
                            if (nameA < nameB)
                                return -1
                            if (nameA > nameB)
                                return 1
                            return 0
                        }).forEach(item => {
                            res.push({text: item.carModelName, value: item.id})
                        });
                        return res;
                    }
                    else return [];
                }
                else  return [];
            },

            packages(){
                return this.$store.state.Bonuses.bonusPackages
            },

            partnerBranches(){
                return this.$store.state.Partners.partnerBranches
            }


        },
        methods:{
            //форматирование номера телефона
            formatPhone(value, e){
                //оставляем только цифры
                value= value.replace(/\D/,"")
                value=value.replace(/^[0-8]/,"")
                return value.substr(0,10);
            },

            resetItems(){
                this.errors = [];
                this.correctLogin=null;
                this.loginMes=null;

                for (var key in this.identityModel) {
                    if(key=='isClient'){
                        this.identityModel[key] = true;
                    }
                    else if(key=='isAdministrator'|| key=='canAddUsers'||key=='canManageBonuses'||
                        key=='canEcxecuteRequests'){
                        this.identityModel[key] = false;
                    }else
                        this.identityModel[key] = null;
                }

                for (var key in this.editClientModel){
                    if(key=='carYear') {
                        var dt= new Date();
                        this.editClientModel[key] = dt.getFullYear();
                    }
                    else if(key=="isActive"||key=='pushEnable')
                        this.editClientModel[key]=true;
                    else
                        this.editClientModel[key]=null;
                }

                if (this.webUserInfo != null) {
                    this.editClientModel.organizationId = this.webUserInfo.organizationId;
                    this.editClientModel.orgGeoInfoId = this.webUserInfo.orgGeoInfoId;
                }
            },

            generatePass(length) {
                var result = '';
                var characters = '0123456789';
                var charactersLength = characters.length;
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            },

            //проверка на наличие логина
            async checkLogin(value) {
                const vm = this;
                if(value!=null&&value!=''){
                    await axios.get(`${vm.$root.identityURL}/api/useraccount/ChekLogin?login=${value}`)
                        .then(response => {
                            if (response.status == 200) {
                                vm.correctLogin = true;
                                vm.loginMes = "Номер телефона не занят";//response.data;
                            }
                        })
                        .catch(error => {
                            if(error.response.status==400){
                                vm.correctLogin = false;
                                vm.loginMes ="По данному номеру уже зарегистрирован полььзователь";// error.response.data;
                            }
                        });
                }

            },

            markSelect(e) {
                //если нет записи о моделях, то подтягиваем с апи
                if (this.editClientModel.carMarkId != null) {
                    var models = this.carModels(this.editClientModel.carMarkId)
                    if (models == null)
                        try {
                            this.$store.dispatch("Cars/loadModels", this.editClientModel.carMarkId).catch(err => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка загрузки моделей авто!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            })
                        } catch (e) {
                            console.log(e);
                        }
                }
            },

            validateModel() {
                var noError = true;
                this.errors = [];

                if (this.editClientModel.fullName == null || this.editClientModel.fullName == '') {
                    this.errors.push({key: "userName", mes: "Необходимо указать ФИО!"});
                    noError = false;
                }

                if (this.editClientModel.account == null || this.editClientModel.account == '') {
                    this.errors.push({key: "account", mes: "Необходимо указать Номер телефона!"});
                    noError = false;
                }


                if (this.editClientModel.carMarkId == null || this.editClientModel.carMarkId == '') {
                    this.errors.push({key: "eMail", mes: "Необходимо выбрать модель авто!"});
                    noError = false;
                }

                if (this.editClientModel.carModelId == null || this.editClientModel.carModelId == '') {
                    this.errors.push({key: "carModelId", mes: "Необходимо выбрать марку авто!"});
                    noError = false;
                }
                if (this.editClientModel.dateBirth == null || this.editClientModel.dateBirth == '') {
                    this.errors.push({key: "dateBirth", mes: "Необходимо дату рождения!"});
                    noError = false;
                }
                if (this.editClientModel.bonusPacketId == null || this.editClientModel.bonusPacketId == '') {
                    this.errors.push({key: "bonusPacketId", mes: "Необходимо выборать тип бонусного пакета!"});
                    noError = false;
                }
                if (this.editClientModel.carYear == null || this.editClientModel.carYear == '') {
                    this.errors.push({key: "carYear", mes: "Необходимо выборать год выпуска ТС!"});
                    noError = false;
                }

                return noError;

            },

            async onSave(){
                const vm = this;
                //проверяем на заполнение полей
                if (this.validateModel() == true) {

                    if (this.editClientModel.id == null) {
                        //приводим модель к идентити
                        mapper.map("editMobileUserModel", "identityModel", this.editClientModel, this.identityModel);
                        var pass = this.generatePass(6); //рандомный шестизначный пароль
                        this.identityModel.password = pass;


                        var UserId = null;
                        //добавляем идентити, получаем ид пользователя
                        await axios.post(`${vm.$root.identityURL}/api/UserAccount/Register`, this.identityModel)
                            .then(response => UserId = response.data)
                            .catch(error => {
                                this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                                    title: `Ошибка!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                        //если пользователь добавлен на идентити
                        if (UserId != null) {
                            this.editClientModel.identityId = UserId;

                            this.$store.dispatch('Clients/addMobileUser', this.editClientModel).then(() => {
                               this.close(true)
                                this.$bvToast.toast("Пользователь успешно добавлен", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            })
                                .catch((err) => {
                                    this.$bvToast.toast(err, {
                                        title: `Ошибка!`,
                                        variant: "danger",
                                        toaster: 'b-toaster-bottom-right',
                                        autoHideDelay: 3000,
                                        solid: true
                                    })
                                });
                        }
                    }
                }
                else {
                    this.errors.forEach(err => {
                        this.$bvToast.toast(err.mes, {
                            title: `Не все поля заполнены!`,
                            variant: "warning",
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 7000,
                            solid: true
                        })
                    })
                }
            },

            close(isSave) {
                this.showSuccess=false
                this.$emit("close", isSave)
            },


        },
        watch:{
            show(value){
                if(value==true){
                    this.resetItems();
                    //получить список филиалов пользователя
                    this.$store.dispatch("Partners/getPartnerBranches", this.webUserInfo.organizationId)
                        .catch(error => {
                            this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                                title: `Ошибка!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                }
            }
        }

    }
</script>

<style scoped>
    .password-send-label{
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: #000000;
    }
</style>